import { merge } from "lodash";
import { POLL_TYPE } from "./../wix-rich-content-common";
import { biStrategy } from "./biStrategy/biStrategy";
import iframeSandboxDomainStrategy from "./iframeSandboxDomainStrategy/iframeSandboxDomainStrategy";
import pollsStrategy from "./pollsStrategy/pollsStrategy";
import {
  hasPlugin as hasPluginInPlugins,
  hasPollsPluginInContent,
  parseInstance
} from "./services";
import urlResolutionStrategy from "./urlResolutionStrategy/urlResolutionStrategy";
const runStrategies = ({
  experiments = {},
  plugins,
  instance,
  wixRicosVersion,
  ricosVersion,
  biSettings,
  getWixClientPromise,
  msid = "",
  viewer = false,
  content
}) => {
  const hasPlugin = (pluginType) => hasPluginInPlugins(pluginType, plugins);
  const { metaSiteId: instanceMsid, appDefId } = parseInstance(instance);
  const metaSiteId = instanceMsid || msid;
  const { ricosFeatures, wixRicosFeatures } = experiments;
  const shouldUsePollStrategy = hasPlugin(POLL_TYPE) && (!viewer || viewer && hasPollsPluginInContent(content));
  return merge(
    { experiments: ricosFeatures },
    biStrategy(appDefId, metaSiteId, wixRicosVersion, ricosVersion, biSettings, wixRicosFeatures),
    urlResolutionStrategy(hasPlugin, instance, metaSiteId, wixRicosFeatures),
    shouldUsePollStrategy && pollsStrategy(instance, getWixClientPromise),
    iframeSandboxDomainStrategy(metaSiteId),
    wixRicosFeatures
  );
};
const runStrategiesWithCommonUtils = (props) => ({
  strategies: runStrategies(props)
});
export {
  runStrategies,
  runStrategiesWithCommonUtils
};
//# sourceMappingURL=runStrategies.js.map
